import React from "react";
import { Card, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, SupportRoutes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  handleAction: ActionHandlerFunction;
}

function NoAddressesViewComponent(props: AllProps) {
  const { handleAction } = props;

  return <Card className="admin-card mt-5">
    <Icon className="trusted-community" />
    <Card.Body>
      <Card.Title as="p">Create a list of trusted addresses</Card.Title>
      <Card.Text as="p">
        <span className="text-muted">Learn More:</span>
        <a target="_blank" href={SupportRoutes.trusted_community} rel="noreferrer"> Trusted Addresses</a>
      </Card.Text>
      <Button variant="primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}>
        <Icon className="icon-plus2" />
        Add to Address List
      </Button>
    </Card.Body>
  </Card >;
}

export default React.memo(NoAddressesViewComponent);
